import {useEffect, useState } from 'react';
import {Form, Select, Input, Button, message} from "antd";
import { useForm } from 'antd/lib/form/Form';
import useHttpClient from 'shared/hooks/http-hook';
import  EndPoints from 'shared/endPoints/EndPoints.json';
import './DeleteTripForm.css'
import MyModal from './MyModal';

export default function DeleteTripForm({tripId, deletedRevokedTrip, setDeletedRevokedTrip, handleExpand}){

    const { Option } = Select;
    const { status, responseData, sendRequest, responseMessage } = useHttpClient();
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [isRevokeModalVisible, setIsRevokeModalVisible] = useState(false);
    const [form] = useForm();
    
    const deleteTrip = (data) => {
        sendRequest({
            endpoint: EndPoints.TRIPS.DELETETRIP,
            method: 'PUT',
            data,
        })
    }

    const revokeTrip = (data) => {
        sendRequest({
            endpoint: EndPoints.TRIPS.REVOKETRIP,
            method: 'PUT',
            data,
        })
    }

    const showModal  = (e) => {
        if(e==='delete'){
            setIsDeleteModalVisible(true)
        }
        else{
            setIsRevokeModalVisible(true)
        }
    };

    const handleModalYes = (e) => {
        if (e==='delete'){
            setIsDeleteModalVisible(false);
            deleteTrip({
                "tripId": tripId,
                "comments": form.getFieldValue('deleteComments')
            })    
        }
        else{
            setIsRevokeModalVisible(false);
            revokeTrip({"tripId": tripId}) 
        }
    };

    const handleModalNo = () => {
        setIsDeleteModalVisible(false);
        setIsRevokeModalVisible(false);
    };

    const handleCancel = () =>{
        form.resetFields();
        handleExpand(tripId)
    } 

    useEffect(() => {
      if (status === 'pending') {
        message.loading()
      }
      if (status === 'resolved') {
        setDeletedRevokedTrip(!deletedRevokedTrip)
        handleExpand(tripId)
        form.resetFields();
        message.success(responseMessage)
      }
    }, [status, responseData, responseMessage])
    
    return(
    <Form form={form}>
        <Form.Item name="deleteType" label="Delete Info">
            <Select allowClear >  
                <Option value="deleteType">ΑΙΤΗΜΑ ΕΤΑΙΡΕΙΑΣ</Option>
            </Select>
        </Form.Item>
        <Form.Item name="deleteComments" label="Comments">
            <Input type="text" onChange={(event)=> form.setFieldsValue("deleteComments",event.target.value)}/> 
        </Form.Item>
        <Button className='trip-button' onClick={handleCancel}>Cancel</Button>
        <Button className='trip-button' onClick={()=>{showModal('revoke')}}>Revoke</Button>
        <MyModal message="Είστε σίγουροι ότι επιθυμείτε να αναιρέσετε τη διαγραφή της συγκεκριμένης διαδρομής;" title="Revoke Trip Confirmation" visible={isRevokeModalVisible} onOk={()=>{handleModalYes('revoke')}} onCancel={handleModalNo} />
        <Button className='trip-button' onClick={()=>{showModal('delete')}}>Delete</Button>
        <MyModal message="Είστε σίγουροι ότι επιθυμείτε να διαγράψετε τη συγκεκριμένη διαδρομή;" title="Delete Trip Confirmation" visible={isDeleteModalVisible} onOk={()=>{handleModalYes('delete')}} onCancel={handleModalNo} />        
    </Form>
    )
}